import { Model } from "@/models";

export type AutomaticReportJobStatus = "todo" | "processing" | "done" | "error";

type AutomaticReportJobUser = {
  id: number;
  email: string;
};

type AutomaticReportJobProfile = {
  id: number;
  name: string;
  slug: string;
};

export default class AutomaticReportJobBase extends Model {
  automaticReportId?: number | null;
  user?: AutomaticReportJobUser | null;
  profile?: AutomaticReportJobProfile | null;
  kind?: string;
  type?: string;
  data!: unknown;
  status!: AutomaticReportJobStatus;
  message?: string | null;

  createdAt!: string;
  updatedAt!: string;
}
